import React from 'react';
import styled from 'styled-components';
import RadioButton from '../../../../Common/BaseComponentWrappers/MotifRadio';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import {GetCardTypeForBody} from '../../../../../util/utils';

function PrintViewSingleSelectTitleBody(props) {
	const {body} = props;

	const formBodyBorder = GetCardTypeForBody(body);

	const mainBodyKey = `form-body-${body.id}-radio`;

	return (
		<StyledPrintViewSingleSelectTitleBody className={`StyledPrintViewSingleSelectTitleBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewRadioButtonBodyData" id={body.id}>
				{body.optionsAndResponses &&
					body.optionsAndResponses.map((data) => {
						return (
							/*<section className="section-radio">*/
							<RadioButton
								key={`${mainBodyKey}-option-${data.bodyOptionId}`}
								radioId={data.bodyOptionId}
								radioName={data.id}
								isChecked={data.bodySelectedOptionId === 1}
								labelValue={data.bodyOptionText}
								title={data.bodyOptionText}
								disabled
								noOfLines="2"
								isPrint
							/>
							/*</section>*/
						);
					})}
			</section>
		</StyledPrintViewSingleSelectTitleBody>
	);
}

export default PrintViewSingleSelectTitleBody;

const StyledPrintViewSingleSelectTitleBody = styled.section`
	.section-radio {
		margin: var(--px-5) var(--px-30) var(--px-15) 0;
		border: var(--px-2) solid var(--neutrals-300);
		background-color: var(--neutrals-00white);
		padding: var(--px-16) var(--px-20);
		min-width: var(--px-300);
		max-width: 100%;
	}
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
	}
	.PrintViewRadioButtonBodyData {
		display: block !important;
		width: 100%;
		margin: var(--px-10) 0 var(--px-10) var(--px-30);
		flex-wrap: wrap;
		.section-radio {
			max-width: var(--px-300);
		}
	}
`;
